"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

require("./ItemCollection.css");
/* eslint-disable react/no-array-index-key */


var ItemCollection =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(ItemCollection, _React$Component);

  function ItemCollection() {
    (0, _classCallCheck2["default"])(this, ItemCollection);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ItemCollection).apply(this, arguments));
  }

  (0, _createClass2["default"])(ItemCollection, [{
    key: "getItems",
    value: function getItems() {
      var _this$props = this.props,
          itemsPerRow = _this$props.itemsPerRow,
          onlyEvenRows = _this$props.onlyEvenRows,
          children = _this$props.children;

      if (onlyEvenRows) {
        return children.slice(0, Math.floor(children.length / itemsPerRow) * itemsPerRow);
      }

      return children;
    }
  }, {
    key: "getHeaderStyle",
    value: function getHeaderStyle() {
      var collectionType = this.props.collectionType;
      if (collectionType === 'custom') return {
        marginLeft: '0.5em',
        marginRight: '1.5em'
      };
      return {};
    }
  }, {
    key: "renderGridCollection",
    value: function renderGridCollection() {
      var _this$props2 = this.props,
          itemsDivided = _this$props2.itemsDivided,
          itemsPerRow = _this$props2.itemsPerRow;
      return _react["default"].createElement(_semanticUiReact.Grid, {
        stackable: true,
        columns: itemsPerRow,
        celled: itemsDivided && 'internally'
      }, this.getItems().map(function (item, index) {
        return _react["default"].createElement(_semanticUiReact.Grid.Column, {
          key: index
        }, item);
      }));
    }
  }, {
    key: "renderItemCollection",
    value: function renderItemCollection() {
      var itemsDivided = this.props.itemsDivided;
      return _react["default"].createElement(_semanticUiReact.Item.Group, {
        relaxed: true,
        divided: itemsDivided
      }, this.getItems());
    }
  }, {
    key: "renderCardCollection",
    value: function renderCardCollection() {
      var itemsPerRow = this.props.itemsPerRow;
      return _react["default"].createElement(_semanticUiReact.Card.Group, {
        itemsPerRow: itemsPerRow,
        stackable: true,
        fluid: true
      }, this.getItems());
    }
  }, {
    key: "renderCollection",
    value: function renderCollection() {
      var collectionType = this.props.collectionType;
      if (collectionType === 'cards') return this.renderCardCollection();
      if (collectionType === 'items') return this.renderItemCollection();
      if (collectionType === 'custom') return this.renderGridCollection();
      return _react["default"].createElement("div", null);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          header = _this$props3.header,
          centerHeader = _this$props3.centerHeader;
      return _react["default"].createElement("div", null, header && _react["default"].createElement(_semanticUiReact.Header, {
        as: "h1",
        textAlign: centerHeader ? 'center' : 'left',
        style: this.getHeaderStyle()
      }, header), this.renderCollection());
    }
  }]);
  return ItemCollection;
}(_react["default"].Component);

exports["default"] = ItemCollection;
ItemCollection.propTypes = {
  collectionType: _propTypes["default"].oneOf(['cards', 'items', 'custom']).isRequired,
  itemsPerRow: _propTypes["default"].number,
  itemsDivided: _propTypes["default"].bool,
  header: _propTypes["default"].string,
  centerHeader: _propTypes["default"].bool,
  onlyEvenRows: _propTypes["default"].bool
};
ItemCollection.defaultProps = {
  centerHeader: false,
  header: '',
  itemsDivided: false,
  itemsPerRow: 3,
  onlyEvenRows: false
};
ItemCollection.propOptions = {};
ItemCollection.dataPropsMap = {};